import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get} from '../../request'
import './styles.scss';


Input.propTypes = {
    title: PropTypes.string,
    path: PropTypes.string,
};

function Input({inputType,checkRequied,  className, placeholder, name, value, onChange, onBlur, error,
    checkUniq, entityId, validType, columnName, minLength, maxLength, onValidInput, pattern, name1}) {
    const [inputValue, setInputValue] = useState(value || '');
    const [isValid, setIsValid] = useState(true);
    const [isUnique, setIsUnique] = useState(true); // 假设初始时输入值是唯一的  
    const [isChecking, setIsChecking] = useState(false); // 用于表示是否正在进行唯一性检查  
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        // 在组件挂载后，立即验证初始值（如果有的话）  
        //validateInput(inputValue);
        //setInputValue(value);       
        if (value != inputValue) {
            setInputValue(inputValue);
        }
    }, [inputValue]);
    const handleInputChange = (value) => {
      
        setErrorMessage("");
        setIsValid(true);

        setInputValue(value);
        if (checkRequied) {
            if (!value) {
                setErrorMessage("不能为空");
                setIsValid(false);
            }            
        }

        if (onChange) {
            onChange(value);
        }
        
    }
    // 处理输入变化  
    const handleInputBlur = (event) => {
        const { value } = event.target;
        setInputValue(value);
        if (checkUniq) {            
            setIsUnique(true); // 假设用户开始输入时，输入值是唯一的  
            checkUniqueness(value);
        }
        if (checkRequied) {
            if (!value) {
                setErrorMessage("不能为空");
                setIsValid(false);
            }
        }
        if (onBlur) {
            onBlur(event);
        }
        if (onValidInput) {
            onValidInput(name, isValid, name1);
        }
    };

    // 调用axios进行唯一性检查  
    const checkUniqueness = async (inputValue) => {
        if (inputValue) {
            setIsChecking(true);
            var params = {
                'id': entityId,
                'name': inputValue,
                'datatype': validType,
                'columnname': columnName
            };
            get('delianapi/validate/nameunique', params).then(response => {
                setIsUnique(response);
                setIsChecking(false);
                setIsValid(false);
            }).catch(error => {
                console.log('Error checking uniqueness:', error);
                setIsUnique(false);
                setIsChecking(false);
            })
        }
    };

    // 根据唯一性检查结果显示不同的样式或消息  
    const inputStyle = isUnique ? {} : { border: 'red 1px solid' };
    const uniquenessMessage = isUnique ? '' : '已存在';
    return (
        <div className="input-container">
            <input
                required={checkRequied}
                placeholder={placeholder}
                type={inputType ? inputType : 'text'}
                name={name}
                value={value}
                onChange={event => handleInputChange(event.target.value)}
                onBlur={event => handleInputBlur(event)}
                className={`input-field ${className} ${error ? 'error' : ''}`}
                style={inputStyle}
                minLength={minLength} maxLength={maxLength}           
            />            
            { checkUniq && (isChecking ?
                <div className="error-message">'正在检查唯一性...'</div> :
                <div className="error-message">{uniquenessMessage}</div>)
            }
            {errorMessage && <div className="error-message">{errorMessage}</div>}
            {error && <div className="error-message">{error}</div>}
        </div>
    );
};

export default Input;